import React, { useRef, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import styles from './styles.module.css'
import MyPanelSVG from '../../../static/assets/icon-my-panel.svg'
import ToolsSVG from '../../../static/assets/icon-tools.svg'
import MenuToolsSVG from '../../../static/assets/menu-tools.svg'
import CredentialsSVG from '../../../static/assets/icon-credentials.svg'
import WebhookSVG from '../../../static/assets/icon-webhook.svg'
import { useToggleHotDropdown } from '../../hooks/useToggleHotDropdown'
import AuthHeaderDynamicMenuItem from './AuthHeaderDynamicMenuItem'

function AuthHeaderDynamicMenu({ tabIndex }) {
  let toolTabIndex = 0
  const getNextToolTabIndex = () => (toolTabIndex += 1)
  const { t } = useTranslation()
  const hotDropdownRef = useRef()
  const { toggle } = useToggleHotDropdown(hotDropdownRef)

  const { dynamicItems } = useMemo(
    () => ({      
      dynamicItems: [
        {
          id: 'menu-credentials',
          title: t('header.menu.dynamic_menu.credentials'),
          route: process.env.URL_CREDENTIALS,
          icon: <CredentialsSVG />,
          available: true,
        },
        {
          id: 'menu-webhook',
          title: t('header.menu.dynamic_menu.webhook'),
          route: process.env.URL_WEBHOOK,
          icon: <WebhookSVG />,
          available: true,
        },
        {
          id: 'menu-tools',
          title: t('header.menu.dynamic_menu.tools'),
          route: process.env.URL_TOOLS,
          icon: <ToolsSVG />,
          available: true,
        },
        {
          id: 'menu-mypanel',
          title: t('header.menu.dynamic_menu.myPanel'),
          route: process.env.URL_MY_PANEL,
          icon: <MyPanelSVG />,
          available: true,
        },
      ],
    }),
    [t]
  )

  function handleMenuKeyDown(event) {
    if (event.key === 'Enter' || event.key === ' ') {
      toggle()
    }
  }

  return (
    <hot-dropdown tabIndex={tabIndex} onKeyDown={handleMenuKeyDown} ref={hotDropdownRef} class={`${styles.headerTools} hot-dropdocked`}>
      <hot-menu-item slot="button" class="_cursor-pointer">
        <div className="hot-application-menu__icon">
          <hot-tooltip content={t('header.menu.general.browse')} position="bottom" class="_d-flex">
            <MenuToolsSVG />
          </hot-tooltip>
        </div>
      </hot-menu-item>
      <div slot="menu" className="_text-gray-600" id="menu-dynamic-items">
        <div className="_p-4">
          <div key="menu1" id="menu1">
            <p className="_mb-2 _pl-4 _text-black">{t('header.menu.general.browse')}</p>
            <div className={`${styles.headerToolsItems}`}>
              {dynamicItems.map(item => (
                <AuthHeaderDynamicMenuItem key={item.id} title={item.title} icon={item.icon} route={item.route} tabIndex={getNextToolTabIndex()} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </hot-dropdown>
  )
}

export default AuthHeaderDynamicMenu
